import { confirmPasswordReset } from 'firebase/auth';
import { getErrorReporter } from 'shared/services/error-tracking';
import { ResetPasswordErrorTypes } from 'shared/types/reset-password-form';
import { mapResetPasswordError } from 'shared/utils/map-reset-password-error';

import { getAuthentication } from './helpers';

export const resetPassword = async (code: string, password: string) => {
  const auth = await getAuthentication();

  try {
    await confirmPasswordReset(auth, code, password);
  } catch (e: unknown) {
    const errorCode = (e as { code?: string } | null)?.code ?? '';
    const kind = mapResetPasswordError(errorCode);
    // A dead link or a weak password is the user's to resolve; anything else is a bug or outage.
    if (kind === ResetPasswordErrorTypes.Unknown) {
      getErrorReporter().captureException(e, {
        tags: { source: 'firebase-reset-password' },
      });
    }
    throw kind;
  }
};
